// src/pages/ContactPage.js
import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config/api";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    const contactFormURl = API_BASE_URL + "contact"; 
    try {
      const { data } = await axios.post(contactFormURl, form);
      alert(`Thank you, ${form.name}! We’ll get back to you soon.`);
      setStatus({ type: "success", message: data.message });
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      setStatus({ type: "error", message: msg });
    }
  }; 

  return (
    <div className="container py-4">
      <h1>Contact Us</h1>
      {status && (
        <div
          className={`alert alert-${
            status.type === "success" ? "success" : "danger"
          }`}
        >
          {status.message}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <label>Email</label>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <label>Message</label>
          <textarea
            name="message"
            rows="4"
            value={form.message}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Send Message
        </button>
      </form>
    </div>
  );
}
